import { Button, Select, Form, Input, message, Popconfirm } from "antd";
import { useState, useEffect, useRef } from "react";

import { useNavigate } from "react-router-dom";

import { Messages, Notify } from "../../services/custom/Messages";
import util from "../../utils/functions/custom";
import service from "../../services/usersService";
import { openNotification } from "@seims/shared";
import { programmes } from "../../utils/apiConstants";
import PrivacyStatment from "../PrivacyStatment";
import { getClosingDate } from "../nyscandidate/NysUtil";

export const RegisterUser = (props) => {
  const formName = "register";
  const [messageApi, contextHolder] = message.useMessage();

  const [selectedProgrammes, setSelectedProgrammes] = useState([]);
  const [programmeData, setProgrammeData] = useState([]);
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const [form] = Form.useForm();
  const { Option } = Select;
  const emailAddressRef = useRef(null);
  const navigate = useNavigate();

  const handleCancel = () => {
    navigate(`/`);
  };

  const passwordRegEx = new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
  );
  const Passwordmessages =
    "Password must be at least 8 characters long, have 1 number,1 uppercase, and 1 special character";

  let msg = "";

  useEffect(() => {
    isNysApplicationOpen();
  }, []);

  const createUser = async (values) => {
    const entity = "User account";
    const hide = message.loading("Submitting in progress, please wait...", 0);

    const { firstname, lastname, emailAddress, password } = values;

    const publicUser = {
      userDetails: {
        firstname: firstname,
        lastname: lastname,
        password: password,
        emailAddress: emailAddress,
        programme: selectedProgrammes,
      },
      acceptedTerms: acceptedTerms,
    };

    let response;
    try {
      response = await service.addUser(publicUser, selectedProgrammes);
    } catch (error) {
      response = error.response;
    }
    hide();
    let action = "Account Registration";
    if (response) {
      if (response.status == 409) {
        msg = util.parseMessage(Messages.PUBLIC_USER_EXISTS, "Email");
        openNotification(action, msg, Notify.ERROR);
        return;
      }
      if (response.status >= 400 && response.status != 409) {
        msg = util.parseMessage(Messages.INVALID_EMAIL_DOMAIN, "Email");
        openNotification(action, msg, Notify.ERROR);
        return;
      }
      if (response.status >= 500) {
        msg = util.parseMessage(Messages.SERVER_REQUEST_FAILURE, "Email");
        openNotification(action, msg, Notify.ERROR);
        return;
      }

      msg = util.parseMessage(Messages.ADD_SUCCESS_ACCOUNT, entity);
      openNotification(action, msg, Notify.SUCCESS);
      localStorage.setItem("nysTerms", false);
      form.resetFields();
      navigate(`/`);
    } else {
      msg = util.parseMessage(Messages.ADD_FAILURE, entity);
      message.error(msg);
    }
  };

  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 24,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 24,
      },
    },
  };
  const info = () => {
    messageApi.info("Copy and Pasting is not allowed for Email address!");
  };

  // Why has the below been implemented? Unless there is a good reason, I am commenting it out with a recommendation to remove.

  // document.addEventListener('contextmenu', event => {
  //   console.log("Event fired: ", event)
  //   event.preventDefault();
  // });

  const isNysApplicationOpen = async () => {
    const nysApplication = await getClosingDate();
    const _showApply = nysApplication?.open || false;
    getProgrammes(_showApply);
  };

  //! For now we are excluding any inactive programme
  const getProgrammes = (includeNYS) => {
    let sorted = programmes
      .toSorted((a, b) => a.value.localeCompare(b.value))
      .filter((c) => c.active
      );
    if (!includeNYS) {
      sorted = sorted.filter((p) => p.key !== "nys-programme" && p.active);
    }

    setProgrammeData(sorted);
  };

  const handleProgrammeChange = (selected) => {
    setSelectedProgrammes(selected);
  };

  const acceptTerms = () => {
    setAcceptedTerms(true);
  };

  const cancelTerms = () => {
    navigate("/");
  };

  return (
    <div>
      {contextHolder}
      {/* <h1>Candidate registartion hhhh</h1> */}
      {!acceptedTerms && (
        // <div className="content-container">
        <>
          <PrivacyStatment />
          <div className="t-and-c-buttons">
            <Button onClick={() => cancelTerms()}>I do not accept</Button>

            <Popconfirm
              title="By clicking I accept you agree to the conditions stated in the privacy statement, proceed?"
              onConfirm={() => acceptTerms()}
              onCancel={() => cancelTerms()}
              okText="Yes"
              cancelText="No"
            >
              {" "}
              &nbsp; &nbsp;
              <Button type="primary">I accept</Button>
            </Popconfirm>
          </div>
        </>
        // </div>
      )}
      {acceptedTerms && (
        <>
          <div class="login-pf-page">
            <div class="register-container">
              <div class="card-pf register-left">
                <img
                  className="img-register"
                  src={require("../../assets/register2.png")}
                />
              </div>
              <div class="card-pf register-right">
                <header class="login-pf-header">
                  <h1 id="kc-page-title">Register</h1>
                </header>
                <div id="kc-content">
                  <div id="kc-content-wrapper">
                    <div id="kc-form">
                      <div id="kc-form-wrapper">
                        <Form
                          name={formName}
                          form={form}
                          onFinish={createUser}
                          {...formItemLayout}
                        >
                          <Form.Item
                            name="firstname"
                            label="First name"
                            rules={[
                              {
                                required: true,
                                message: "Please enter your firstname",
                              },
                            ]}
                          >
                            <Input />
                          </Form.Item>
                          <Form.Item
                            name="lastname"
                            label="Last name"
                            rules={[
                              {
                                required: true,
                                message: "Please enter your lastname",
                              },
                            ]}
                          >
                            <Input />
                          </Form.Item>

                          <Form.Item
                            name="emailAddress"
                            label="Email"
                            rules={[
                              {
                                type: "email",
                                message: "The input is not valid E-mail",
                              },
                              {
                                required: true,
                                message: "Please enter your E-mail",
                              },
                            ]}
                            hasFeedback
                            onPaste={(e) => {
                              e.preventDefault();
                              return false;
                            }}
                            onCopy={(e) => {
                              e.preventDefault();
                              info();
                              return false;
                            }}
                          >
                            <Input ref={emailAddressRef} />
                          </Form.Item>
                          <Form.Item
                            name="Email confirmation"
                            label="Confirm Email"
                            dependencies={["emailAddress"]}
                            hasFeedback
                            onPaste={(e) => {
                              e.preventDefault();
                              return false;
                            }}
                            onCopy={(e) => {
                              e.preventDefault();
                              return false;
                            }}
                            rules={[
                              {
                                type: "email",
                                message: "The input is not valid E-mail",
                              },
                              {
                                required: true,
                                message: "Please enter your E-mail",
                              },
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  if (
                                    !value ||
                                    getFieldValue("emailAddress") === value
                                  ) {
                                    return Promise.resolve();
                                  }

                                  return Promise.reject(
                                    new Error(
                                      "The two email that you entered do not match!"
                                    )
                                  );
                                },
                              }),
                            ]}
                          >
                            <Input ref={emailAddressRef} />
                          </Form.Item>

                          <Form.Item
                            name="password"
                            label="Password"
                            rules={[
                              {
                                required: true,
                                message: Passwordmessages,
                                pattern: passwordRegEx,
                              },
                            ]}
                            hasFeedback
                          >
                            <Input.Password />
                          </Form.Item>

                          <Form.Item
                            name="Password confirmation"
                            label="Confirm Password"
                            dependencies={["password"]}
                            hasFeedback
                            rules={[
                              {
                                required: true,
                                message: Passwordmessages,
                                pattern: passwordRegEx,
                              },
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  if (
                                    !value ||
                                    getFieldValue("password") === value
                                  ) {
                                    return Promise.resolve();
                                  }

                                  return Promise.reject(
                                    new Error(
                                      "The two passwords that you entered do not match!"
                                    )
                                  );
                                },
                              }),
                            ]}
                          >
                            <Input.Password />
                          </Form.Item>
                          <Form.Item
                            name="Programmes"
                            label="Programmes"
                            rules={[
                              {
                                required: true,
                                message: "Please select at least one programme",
                              },
                            ]}
                          >
                            {/* <Select
                              onChange={handleProgrammeChange}
                              value={selectedProgrammes}
                              treeData={withAllSelector(selectedProgrammes, setSelectedProgrammes, programmeData)}
                              placeholder={'Select Programmes'}
                              maxTagCount={2}
                              maxTagPlaceholder={omittedValues =>
                                `+ ${omittedValues.length} Others..`
                              }
                              {...tProps}
                            /> */}
                            <Select
                              allowSearch
                              onChange={handleProgrammeChange}
                              value={selectedProgrammes}
                              placeholder={"Select Programme"}
                            >
                              {programmeData.map((module) => (
                                <Option key={module.key} value={module.key}>
                                  {module.value}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                          <Form.Item style={{ marginBottom: 15 }}>
                            <Button
                              type="primary"
                              htmlType="submit"
                              className="pf-c-button pf-m-primary pf-m-block btn-lg register-form-buttons"
                            >
                              Register
                            </Button>{" "}
                          </Form.Item>
                          <Form.Item style={{ marginBottom: 0 }}>
                            <Button
                              type="default"
                              className="pf-c-button pf-m-primary pf-m-block btn-lg register-cancel-form-buttons"
                              onClick={() => handleCancel()}
                            >
                              Cancel
                            </Button>
                          </Form.Item>
                        </Form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div class="clear"></div> */}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
